import src from "IMAGE";
export default { src, width: 383, height: 119, blurWidth: 0, blurHeight: 0};
